import { ReactNode } from 'react'

import { Box, Grid } from '@mui/material'

import { initialDialog } from 'constants/dialog'
import DialogTeleport from './DialogTeleport'
import { DialogData } from 'types/dialog'

type Props = {
  size: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  children: ReactNode
  previewDialog: DialogData
  setPreviewDialog: (value: DialogData) => void
  headerContent?: ReactNode
}

export default function SurveyPreviewDialog({
  size,
  children,
  previewDialog,
  setPreviewDialog,
  headerContent,
}: Props) {
  return (
    <DialogTeleport
      dialogOpen={previewDialog.isOpen}
      dialogSize={size}
      dialogTitle=''
      handleDialogClose={() => setPreviewDialog(initialDialog)}
    >
      {headerContent && (
        <Box
          sx={{
            position: { xs: 'static', md: 'sticky' },
            top: 0,
            zIndex: 1400,
            mt: { xs: '48px', md: 0 },
            pr: { xs: 0, md: '56px' },
            mb: 1,
          }}
        >
          {headerContent}
        </Box>
      )}
      <Grid container>
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </DialogTeleport>
  )
}
